module.exports = __webpack_public_path__ + "static/media/VIP_Ticket@3x.f02a2cb6.png";